export const SET_CHOOSE_LABEL = 'SET_CHOOSE_LABEL'
